import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss']
})
export class AuthenticateComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.authService.generateTwitterAuthUrl().subscribe(resTwitterAuthUrl => {
      if (resTwitterAuthUrl.status === 'verified') {
        window.location.href = 'http://localhost:4300/helpdesk/ticket-view/all';
      } else if (resTwitterAuthUrl.status === 'unverified') {
        localStorage.setItem('oauth_credentials', JSON.stringify(resTwitterAuthUrl.oauth_credentials));
        window.location.href = resTwitterAuthUrl.auth_url;
      } else {
        this.router.navigate(['/dashboard']);
      }
    }, err => {
      console.log(err);
      // this.router.navigate(['/dashboard']);
    });
  }

}
